import React from "react";
import { navLinks, brand } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[var(--black)] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="font-serif-display text-2xl font-semibold text-white">{brand.name}</div>
            <p className="text-xs tracking-[0.3em] uppercase text-white/55 mt-2">
              Double Your Exports
            </p>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
              Helping ambitious manufacturers show their true capabilities to the world.
            </p>
          </div>

          <div className="md:justify-self-center">
            <div className="text-sm font-semibold text-white/80 mb-4">Explore</div>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/60 hover:text-[var(--gold-soft)] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:justify-self-end">
            <div className="text-sm font-semibold text-white/80 mb-4">Get in touch</div>
            <a href={`tel:${brand.phoneRaw}`} className="block text-sm text-white/60 hover:text-[var(--gold-soft)] transition-colors">
              {brand.phone}
            </a>
            <a href={`https://wa.me/${brand.phoneRaw}`} target="_blank" rel="noopener noreferrer" className="block mt-3 text-sm text-white/60 hover:text-[var(--gold-soft)] transition-colors">
              WhatsApp
            </a>
            <a href="/#contact" className="btn-gold inline-flex mt-6 px-5 py-2.5 rounded-full text-sm">
              Book a Call
            </a>
          </div>
        </div>

        <div className="gold-line my-10 opacity-50" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <span>© {new Date().getFullYear()} {brand.name}, {brand.firm}. All rights reserved.</span>
          <span>Export Marketing Strategist and Author</span>
        </div>
      </div>
    </footer>
  );
}
